<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 140px;" size="small " placeholder="请输入姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.auDepartment" style="width: 140px;" size="small " placeholder="请输入部门"
                        clearable></el-input>
                    <el-select v-model="formDatas.auClothesType" clearable @change="partserch" placeholder="请选择"
                        style="width: 150px" size="small">
                        <el-option label="七件套" :value="1" key="1"></el-option>
                        <el-option label="九件套" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.auClothesStatus" clearable @change="partserch" placeholder="请选择"
                        style="width: 150px" size="small">
                        <el-option label="未领取" :value="1" key="1"></el-option>
                        <el-option label="已申请" :value="2" key="2"></el-option>
                        <el-option label="已领取" :value="3" key="3"></el-option>
                        <el-option label="已放弃" :value="4" key="4"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="small" style="margin-left: 20px" @click="batchHand"
                        v-if="iuId == 4">导出全部头像</el-button>
                    <el-button type="primary" size="small" style="margin-left: 20px" @click="batchHandExcel"
                        v-if="iuId == 4">导出全部excel</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="auId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import {
    addAjUserPostRecord, getAjUserPostRecordList, updateAjUserPostRecord, getAssetsAjUserSyn,
    getAjUserListHeader, addAjUser, updateAjUser, deleteAjUser, getAjUserDepartmentList,
    getSysNationList, exportAjUserWord, uploadAjUser, getAjUserDetails, updateAjUserDepartments,
    updateAjFittingsAssetsUnbinding, updateAjFittingsAssets, updateAjUserCheck,
    uploadImportAjUser, exportAjUser, getAjUserBorrowReturnList, updateAjUserIdCard, updateAjUserCertificate,
    getSysRegionList, getAjUserWordList, updateAjUserWord, updateAjUserLeave, updateAjUserBank, updateAjUserContact,
    getAjUserItem, getAjUserBelongList,

} from "../../api/api";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
export default {
    name: "",
    components: {},
    data() {
        return {
            iuId: '',
            aubName_arr: [],
            Isdepartment: false,
            auDepartmentArr: [],
            auDepartment: '',
            updatamsg: '暂无数据',
            updataData: [],

            Isupdata: false,
            editTf: false,
            formTf: {
                auprId: '',
                auprNameTo: '',
                auprNameDtTo: '',
                auprDate: '',
            },
            AddtransferShow: false,
            transferData: [],

            transferShow: false,
            IsConact: false,
            conactType: 0,
            formLevel: {

            },
            IsLevel: false,
            wordType: '',
            wordtypenum: 1,
            wordData: [],
            IsWord: false,
            bankShow: '',
            familyShow: [],
            education: '全日制',
            auAddressNowPL: '请选择地区',
            auAddressNowvalue: '',
            auAddressNowDetail: '',
            auOriginPL: '请选择地区',
            auOriginvalue: '',
            props: {
                lazy: true,
                lazyLoad(node, resolve) {
                    //console.log(node);
                    const { level } = node;
                    getSysRegionList({ srSuperiorCode: node.value }).then(res => {
                        const nodes = res.data.map(item => ({
                            value: item.srCode,
                            label: item.srName,
                            leaf: level >= 2
                        }))
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    })

                }
            },
            auOriginArr: [],
            type: '',
            IsImg: false,
            TypeId: 0,
            EditArr: [],
            HistoryData: [],
            IsHistory: false,
            sitId: '',
            TemstrongArr: [],
            importData: {},
            bulkData: [],
            bulkDataCopy: [],

            bulkImport: false,
            dateUpdata: '',
            dbtrue: false,

            xlfileList: [],
            CyfileList: [],
            limit: 1,
            UpfileList: [],
            DownfileList: [],
            upload: false,

            form: {

            },
            rules: {
                afName: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }
                ],
                afNumber: [{
                    required: true,
                    message: '请输入编号',
                    trigger: 'blur'
                }
                ],
            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            editOption2: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange2(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            tableDataCopy: [],
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auBelong",
                    key: "auBelong",
                    title: "归属",
                    width: 80,
                    align: "center",
                    fixed: 'left',
                    edit: false,
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    fixed: 'left',
                    width: 80,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    width: 60,
                    align: "center",
                    edit: false,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "所在部门",
                    width: 200,
                    align: "center",
                    edit: false,
                },
                {
                    field: "auIdcard",
                    key: "auIdcard",
                    title: "身份证号码",
                    align: "center",
                    width: 160,
                    edit: false,
                },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    width: 90,
                    edit: false,
                },
                {
                    field: "auDateRegular",
                    key: "auDateRegular",
                    title: "试用期结束时间",
                    align: "center",
                    width: 90,
                    edit: false,
                },
                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auHeader",
                    key: "auHeader",
                    title: "头像",
                    width: 50,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:80%;">
                                    {
                                        row.auHeader ? <el-image ref="scrImg" id="scrimg" src={row.auHeader} alt="" fit="cover" style="width: 80%;height: 50px;"
                                            previewSrcList={[row.auHeader]}></el-image> : <span></span>
                                    }
                                </div>
                            </span>
                        )
                    },
                },
                {
                    field: "auClothesType",
                    key: "auClothesType",
                    title: "工装类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.auClothesType == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        七件套
                                    </el-tag>
                                ) : row.auClothesType == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        九件套
                                    </el-tag>
                                ) : ''}

                            </span>
                        )
                    },
                },

                {
                    field: "auClothesStatusDes",
                    key: "auClothesStatusDes",
                    title: "工装领取状态描述",
                    align: "center",
                    width: 150,
                    edit: false,

                },
                {
                    field: "auClothesFeiDes",
                    key: "auClothesFeiDes",
                    title: "工装费用描述",
                    align: "center",
                    width: 150,
                    edit: false,

                },
                {
                    field: "auClothesStatus",
                    key: "auClothesStatus",
                    title: "工装领取状态",
                    align: "center",
                    width: 120,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.auClothesStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        未领取
                                    </el-tag>
                                ) : row.auClothesStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        已申请
                                    </el-tag>
                                ) : row.auClothesStatus == 3 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        已放弃
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },

            ], //表格的列
            tableData: [],
            post: null,
            auId: '',
            formDatas: {
                auNameListString: '',
                auBelongListString: '',
                auDepartmentListString: '',
                auPostListString: '',
                auSexListString: '',
                auDateEntryListString: '',
                auProbationPeriodListString: '',
                auDateRegularListString: '',
                auDateTransferListString: '',
                auStatusListString: '',
                auInterviewerListString: '',
                auDateExpirationContractListString: '',
                auClothesType:'',
                auClothesStatus:'',


                auName: '',
                auBelong: '',
                auDepartment: '',
                auPost: '',
                auSex: '',
                auIdcard: '',
                auAgeStart: '',
                auAgeEnd: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                auStatus: '',
                auInterviewer: '',
                auAddressRegisteredType: '',
                auIdcardExpirationStart: '',
                auIdcardExpirationEnd: '',
                auSchool: '',
                auMajor: '',
                auEducationLevel: '',
                auGraduationTimeStart: '',
                auGraduationTimeEnd: '',
                auEducationLevelMax: '',
                auDepartment: '',
                auSocialSecurityNum: '',
                auProvidentFund: '',
                auInformationEntry: '',
                checkStatus: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.iuId = localStorage.getItem("iuId");
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getSysNationList().then(res => {
            this.auNationArr = res.data
        })
        getAjUserBelongList().then(res => {
            this.aubName_arr = res.data
        })
        getSysRegionList().then(res => {
            res.data.forEach((item, index) => {
                const obj = {
                    value: item.srCode,
                    label: item.srName,
                    children: [],
                }
                this.auOriginArr.push(obj)
            })

        })
        // getAjUserDepartmentList({ pageSize: 0 }).then((res) => {
        //     res.data.forEach((item, index) => {
        //         const s = {
        //             value: item.audId,
        //             label: item.audName,
        //         }
        //         if (item.ajUserDepartmentListChild.length > 0) {
        //             s.children = []
        //             item.ajUserDepartmentListChild.forEach((data, id) => {
        //                 const ss = {
        //                     value: data.audId,
        //                     label: data.audName,
        //                 }

        //                 s.children.push(ss)
        //             })
        //         };
        //         this.auDepartmentArr.push(s)
        //     })
        // });

        this.getList();
    },
    mounted() {


    },
    methods: {
        IsdepartmentClick() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.Isdepartment = true;
            }
        },
        IsdepartmentClose() {
            this.Isdepartment = false
            this.auDepartment = '';
        },
        sureIsdepartment() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var formdata = this.auDepartment[0] || this.auDepartment;
                    if (this.auDepartment.length > 1) {
                        formdata = this.auDepartment[this.auDepartment.length - 1]
                    }
                    updateAjUserDepartments({ audId: formdata, auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                            });
                            this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = [];
                            this.IsdepartmentClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        batchHand() {
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-user-other/getAjUserHeaderFile',
                data: '',
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('iuId')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/x-zip-compressed"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", 'hand.zip');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })

        },
        batchHandExcel() {
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-user-other/exportAjUserOther',
                data: '',
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('iuId')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", 'userheader.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                    //    that.BulkClose()
                }
            })

        },
        batchWord() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && this.selectedRowKeysCollection.length < 2) {
                //console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                const bulkdata = {
                    auIds: this.selectedRowKeysCollection.toString()
                }
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-user/exportAjUserWord',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.documentl"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '花名册.doc');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                //console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                const bulkdata = {
                    auIds: this.selectedRowKeysCollection.toString()
                }
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-user/exportAjUserWord',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/x-zip-compressed"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '花名册.zip');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        IsupdataClose() {
            this.Isupdata = false;
            this.updataData = []
            this.updatamsg = '暂无数据';
            this.getList();
        },
        SynchronizeUpdates() {
            this.openLoading()

            getAssetsAjUserSyn({ auIds: this.selectedRowKeysCollection.toString() })
                .then(res => {
                    if (res.data == "2") {
                        this.loadings.close();
                        this.$message({
                            type: "wraning",
                            message: "用户已审核!",
                        });
                    } else if (Array.isArray(res.data)) {
                        this.loadings.close();
                        this.Isupdata = true;
                        this.updataData = res.data;
                    } else {
                        this.loadings.close();
                        this.Isupdata = true;
                        this.updatamsg = res.data;

                    }
                })

        },
        transferShowClose() {
            this.transferShow = false;
            this.getList()
        },
        transferList() {
            getAjUserPostRecordList({ auId: this.auId }).then(res => {
                this.transferData = res.data;
            })
        },
        transferEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formTf = data;
            this.editTf = true;
            this.AddtransferShow = true;
        },
        AddtransferClick() {
            this.formTf.auId = this.auId;
            this.AddtransferShow = true;
            this.editTf = false;
        },
        transferClose() {
            this.formTf = {
                auprId: '',
                auprNameTo: '',
                auprNameDtTo: '',
                auprDate: '',
            };
            this.AddtransferShow = false;
        },
        transferSure() {
            if (this.editTf) {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjUserPostRecord(this.formTf).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "成功!",
                                });
                                this.transferClose()
                                this.transferList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要新增吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUserPostRecord(this.formTf).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "成功!",
                                });
                                this.transferClose()
                                this.transferList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        transferClick(row) {
            this.auId = row.auId;
            getAjUserPostRecordList({ auId: row.auId }).then(res => {
                this.transferData = res.data;
                this.transferShow = true;
            })
        },
        async ob(i, item) {
            const filterarr = []
            const data = await getAjUserItem({ item, itemStatus: 1 })

            if (this.formDatas[item + 'ListString']) {
                const arr = this.formDatas[item + 'ListString'].split(',')
                arr.forEach((datas, i) => {
                    data.data.forEach((ite, index) => {
                        if (datas == ite.name) {
                            //console.log(datas);
                            const s = {
                                label: ite.name + `(${ite.num})`,
                                selected: true,
                                value: index
                            }
                            filterarr.push(s)

                        }
                        const s = {
                            label: ite.name + `(${ite.num})`,
                            selected: true,
                            value: index
                        }
                        filterarr.push(s)
                    })
                })
                let map = new Map();
                let filterList = []
                for (let itt of filterarr) {
                    map.set(itt.id, itt)
                }
                filterList = [...map.values()]
                filterarr = filterList
            } else {
                data.data.forEach((ite, index) => {
                    //console.log('初始化');
                    const s = {
                        label: ite.name + `(${ite.num})`,
                        selected: false,
                        value: index
                    }
                    filterarr.push(s)
                })
            }
            this.$nextTick(() => {
                this.$set(this.columns[i].filter, 'filterList', filterarr)
                this.$refs['vetable'].colgroups[i].filter.filterList = filterarr

            })
        },
        CloseConact() {
            this.IsConact = false;
            this.conactType = 0;
        },
        sureConact() {
            if (this.conactType == 1) {
                // 银行卡信息编辑
                updateAjUserBank(this.form).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.CloseConact()
                        this.getList()
                    }
                })
            } else {
                // 家庭信息编辑
                updateAjUserContact(this.form).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.CloseConact()
                        this.getList()
                    }
                })
            }
        },
        getConact(row, type) {
            this.form = JSON.parse(JSON.stringify(row));
            this.conactType = type;
            this.IsConact = true;
        },
        CloseLevel() {
            this.formLevel = {};
            this.IsLevel = false;
        },
        sureLevel() {
            this.$confirm("是否确定要离职吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserLeave(this.formLevel).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "离职成功!",
                            });
                            this.CloseLevel()
                            this.getList()
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        levelDate(row) {
            this.IsLevel = true;
            this.formLevel.auId = row.auId
            this.form.auId = row.auId
        },
        Closeword() {
            this.IsWord = false;
            this.wordtypenum = 1;
            this.wordType = '';
        },
        sureword() {
            exportAjUserWord({
                auId: this.auId, auwId: this
                    .wordType
            }).then(res => {
                if (res.data) {

                    window.location.href = res.data;
                    this.$message({
                        type: "success",
                        message: '导出成功',
                    });
                    this.Closeword()
                }
            })
        },
        Handleword() {
            getAjUserWordList().then(res => {
                this.wordData = res.data;
                this.IsWord = true;
                this.wordtypenum = 1
            })

        },
        expandChange(e) {
            //console.log(e);


        },
        handleChange(value) {
            //console.log(value);
            let nodesInfo = this.$refs['cascader'].getCheckedNodes()
            this.form.auOrigin = nodesInfo[0].pathLabels.join('/');
            //console.log(this.form.auOrigin, nodesInfo)
        },
        expandChange2(e) {
            //console.log(e);


        },
        handleChange2(value) {
            //console.log(value);
            let nodesInfo = this.$refs['cascader2'].getCheckedNodes()
            this.form.auAddressNow = nodesInfo[0].pathLabels.join(' ');
            //console.log(this.form.auAddressNow, nodesInfo)
        },
        sureImg() {
            if (this.type == 1) {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const s = {
                            auId: this.auId,
                            auIdcardUp: this.form.auIdcardUp,
                            auIdcardDown: this.form.auIdcardDown
                        }
                        updateAjUserIdCard(s).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const s = {
                            auId: this.auId,
                            auCertificateEducation: this.form.auCertificateEducation,
                            auCertificateEducationCheck: this.form.auCertificateEducationCheck
                        }
                        updateAjUserCertificate(s).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

            // 
        },

        handleImg(row, type) {
            this.auId = row.auId;
            this.type = type;
            this.IsImg = true;
            const data = JSON.parse(JSON.stringify(row))
            this.$nextTick(() => {
                const obj = {
                    UpfileList: 'auIdcardUp',
                    DownfileList: 'auIdcardDown',
                    xlfileList: 'auCertificateEducation',
                    CyfileList: 'auCertificateEducationCheck'
                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            //console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            })
        },
        handleHistory(row) {
            getAjUserBorrowReturnList({ auId: row.auId }).then(res => {
                this.HistoryData = res.data;
                this.IsHistory = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },

        Out(command) {
            //console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                //console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjUser({ userStatus: 1, auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                exportAjUser({ userStatus: 1, exportType: 1 }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },


        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        searchByNameFieldCopy(labels, id) {
            if (labels == []) {
                this.formDatas[id] = '';

                this.partserch()
                return
            }
            const arr = labels
            labels.forEach((item, index) => {
                const a = item.indexOf('(');
                arr[index] = item.substring(0, a);

            })
            this.formDatas[id] = arr.toString();

            this.partserch()
            // this.bulkData = this.bulkDataCopy.filter(
            //     (x) => labels.length === 0 || labels.includes(x[id]),
            // );
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjUser({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {

            //console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjUser(Data).then(res => {
                //console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        filterTag(value, row) {
            return row.status == value;
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },

        handWord(row) {
            this.auId = row.auId
            getAjUserWordList().then(res => {
                this.wordData = res.data;

            })
            this.IsWord = true;
            this.wordtypenum = 2

        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = this.keysId
                    updateAjUser(jsonObj).then(res => {
                        if (res.status == 200) {
                            this.$nextTick(() => {
                                //console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                            });
                            this.dbtrue = false;
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr) {
            //console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.EditArr = Arr

        },

        handleCheck(row) {
            this.$confirm("是否确定要审核通过吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserCheck({ auId: row.auId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        XlfileChange(file) {
            this.$set(this.form, 'auCertificateEducation', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        CyfileChange(file) {
            this.$set(this.form, 'auCertificateEducationCheck', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        UpremoveAfter() {
            this.form.auNation = '';
            this.form.auBirth = '';
            this.form.auIdcard = '';
            this.form.auIdcardAddress = '';
            this.form.auOrigin = '';
            this.form.auIdcardUp = '';
        },
        DownremoveAfter() {
            this.form.auIdcardIssuingAuthority = '';
            this.form.auIdcardExpiration = '';
            this.form.auIdcardDown = '';
        },
        auIdcardUpfileChange(file) {
            //console.log(file);
            if (file[0].idCardInfo) {
                getAjUserDetails({ auIdcard: file[0].idCardInfo.idCardNum }).then(res => {
                    if (res.data && res.data != '资料已审核') {
                        // this.$confirm("该身份证已经存在, 点击确定继续修改,点击取消重新填写?", "提示", {
                        //     confirmButtonText: "确定",
                        //     cancelButtonText: "取消",
                        //     type: "warning",
                        // })
                        //     .then(() => {
                        //         this.$nextTick(() => {
                        //             const sss = JSON.parse(JSON.stringify(res.data))
                        //             this.form = sss;
                        //             this.auOriginPL = res.data.auOrigin;
                        //             const arr = res.data.auEducationLevel.split(' ');

                        //             this.education = arr[0]
                        //             this.form.auEducationLevel = arr[1]
                        //             //console.log(arr);
                        //             const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                        //             if (res.data.auAddressNow) {
                        //                 const adress = res.data.auAddressNow.match(reg)
                        //                 const area = adress[0] + adress[1] + adress[2]
                        //                 this.auAddressNowPL = area
                        //             }
                        //             // // 判断银行
                        //             // if (res.data.auBankCardPf) {
                        //             //     this.bankShow = 1
                        //             // } else if (res.data.auBankCardOther || res.data.auBankCardOtherNum || res.data.auBankCardOtherOpen) {
                        //             //     this.bankShow = 2
                        //             // }
                        //             // if (res.data.auContactDad) {
                        //             //     this.familyShow.push('1')

                        //             // } else if (res.data.auContactMom) {
                        //             //     this.familyShow.push('2')
                        //             // } else if (res.data.auContactSibling) {
                        //             //     this.familyShow.push('3')
                        //             // }
                        //             const obj = {
                        //                 UpfileList: 'auIdcardUp',
                        //                 DownfileList: 'auIdcardDown',
                        //                 xlfileList: 'auCertificateEducation',
                        //                 CyfileList: 'auCertificateEducationCheck'
                        //             }
                        //             for (let item in obj) {
                        //                 if (res.data[obj[item]]) {
                        //                     const img = {
                        //                         name: res.data[obj[item]],
                        //                         url: res.data[obj[item]],
                        //                     }
                        //                     this.$set(this[item], 0, img)
                        //                 }
                        //             }
                        //             if (!sss.auIdcardUp) {
                        //                 this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                        //             }

                        //         })

                        //     }).catch(() => {
                        this.$nextTick(() => {
                            const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                            const adress = file[0].idCardInfo.address.match(reg)
                            const area = adress[0] + adress[1] + adress[2]
                            this.$set(this.form, 'auOrigin', area)
                            // this.$set(this.auOriginvalue,area)
                            this.auOriginPL = area;
                            this.$forceUpdate()
                            const img = {
                                name: file[0].idCardInfo.cardImageFront,
                                url: file[0].idCardInfo.cardImageFront,
                            }
                            this.$set(this.UpfileList, 0, img)
                            this.$set(this.form, 'auAddressRegistered', file[0].idCardInfo.addressSimple)
                            this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                            this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                            this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                            this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                            this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                            this.$set(this.form, 'auName', file[0].idCardInfo.name)
                            this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                            this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                            //console.log(this.form);
                            //console.log(file[0].idCardInfo.address.match(reg))
                            // auAddressRegistered
                        })
                        // })

                    } else {
                        //console.log('11');
                        this.$nextTick(() => {
                            const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                            const adress = file[0].idCardInfo.address.match(reg)
                            const area = adress[0] + adress[1] + adress[2]
                            this.$set(this.form, 'auOrigin', area)
                            this.auOriginPL = area;
                            const img = {
                                name: file[0].idCardInfo.cardImageFront,
                                url: file[0].idCardInfo.cardImageFront,
                            }
                            this.$set(this.UpfileList, 0, img)
                            this.$set(this.form, 'auAddressRegistered', file[0].idCardInfo.addressSimple)
                            this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                            this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                            this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                            this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                            this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                            this.$set(this.form, 'auName', file[0].idCardInfo.name)
                            this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                            this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                            //console.log(this.form);
                            //console.log(file[0].idCardInfo.address.match(reg))
                        })
                        this.$message({
                            type: "success",
                            message: "上传成功!",
                        });
                    }
                })

            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }
        },
        auIdcardUpfileChangeTwo(file) {
            //console.log(file);
            if (file[0].idCardInfo) {
                this.$nextTick(() => {
                    const img = {
                        name: file[0].idCardInfo.cardImageFront,
                        url: file[0].idCardInfo.cardImageFront,
                    }
                    this.$set(this.UpfileList, 0, img)
                    this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                    this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                    this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                    this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                    this.$set(this.form, 'auOrigin', file[0].idCardInfo.addressSimple)
                    this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                    this.$set(this.form, 'auName', file[0].idCardInfo.name)
                    this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                    this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                    //console.log(this.form);
                })
            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }
        },
        auIdcardDownfileChange(file) {
            if (file[0].idCardInfo) {
                this.$nextTick(() => {
                    this.$set(this.form, 'auIdcardIssuingAuthority', file[0].idCardInfo.issuingAuthority)
                    this.$set(this.form, 'auIdcardExpiration', file[0].idCardInfo.expirationDate)
                    this.$set(this.form, 'auIdcardDown', file[0].idCardInfo.cardImageBack || file[0].address)
                    //console.log(this.form);
                })
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }

        },
        sureRelated() {
            this.$confirm("是否确定要添加吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittinsgAssets({ auId: this.DetailArr.auId, aaId: this.form.aaId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.auId)
                            this.$message({
                                type: "success",
                                message: "添加成功!",
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        addRelated() {
            this.form.aaId = this.DetailArr.ajAssets.aaId || '';
            this.Related = true;
        },
        removeRelated() {
            this.$confirm("是否确定要解除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsAssetsUnbinding({ auId: this.DetailArr.auId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.auId)
                            this.$message({
                                type: "success",
                                message: "解除成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        closeSizer() {
            this.formDatas = {
                auName: '',
                auBelong: '',
                auDepartment: '',
                auPost: '',
                auSex: '',
                auIdcard: '',
                auAgeStart: '',
                auAgeEnd: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                auStatus: '',
                auInterviewer: '',
                auAddressRegisteredType: '',
                auIdcardExpirationStart: '',
                auIdcardExpirationEnd: '',
                auSchool: '',
                auMajor: '',
                auEducationLevel: '',
                auGraduationTimeStart: '',
                auGraduationTimeEnd: '',
                auEducationLevelMax: '',
                auDepartment: '',
                auSocialSecurityNum: '',
                auProvidentFund: '',
                auInformationEntry: '',
                checkStatus: '',

                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        getDetail(id) {
            getAjUserDetails({ auId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                //console.log(this.DetailArr);
            });

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjUser({ auIds: row.auId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                const arr = data.auEducationLevel.split(' ');
                this.education = arr[0]
                this.form.auEducationLevel = arr[1]
                this.auOriginPL = data.auOrigin;
                const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                // 判断银行
                if (data.auBankCardPf) {
                    this.bankShow = 1
                } else if (data.auBankCardOther || data.auBankCardOtherNum || data.auBankCardOtherOpen) {
                    this.bankShow = 2
                }
                if (data.auContactDad) {
                    this.familyShow.push('1')
                } else if (data.auContactMom) {
                    this.familyShow.push('2')
                } else if (data.auContactSibling) {
                    this.familyShow.push('3')
                }
                if (data.auAddressNow) {

                    const adress = data.auAddressNow.match(reg)
                    const area = adress[0] + adress[1] + adress[2]
                    this.auAddressNowPL = area
                }

                const obj = {
                    UpfileList: 'auIdcardUp',
                    DownfileList: 'auIdcardDown',
                    xlfileList: 'auCertificateEducation',
                    CyfileList: 'auCertificateEducationCheck'
                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            //console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            })

        },
        SureBtn() {
            if (!this.edit) {
                this.form.auEducationLevel = this.education + ' ' + this.form.auEducationLevel;
                //console.log(this.form.auEducationLevel);
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUser(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.auEducationLevel = this.education + ' ' + this.form.auEducationLevel
                        updateAjUser(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        CloseImg() {
            this.IsImg = false;
            //console.log(this.$refs.upcard2);
            setTimeout(() => {
                this.$refs.upcard2.fileAllRemove()
                this.$refs.Downcard2.fileAllRemove()
                this.$refs.xlupload2.fileAllRemove()
                this.$refs.Cyupload2.fileAllRemove()
                this.UpfileList = [];
                this.DownfileList = [];
                this.xlfileList = [];
                this.CyfileList = [];
            }, 10)
            // this.$nextTick(() => {

            // })


        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            //console.log(this.$refs.upcard);
            this.IsImg = false;
            this.bankShow = '';
            this.familyShow = [];
            this.$nextTick(() => {
                this.$refs['formRef'].resetFields();
                this.$refs.upcard.fileAllRemove()
                this.$refs.Downcard.fileAllRemove()
                this.$refs.xlupload.fileAllRemove()
                this.$refs.Cyupload.fileAllRemove()
                this.auAddressNowvalue = '';
                this.auOriginvalue = '';
                this.auAddressNowPL = '请选择地区';
                this.auOriginPL = '请选择地区';
                this.UpfileList = [];
                this.DownfileList = [];
                this.xlfileList = [];
                this.CyfileList = [];
            })


        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = row.auId
                    //console.log(jsonObj);
                    updateAjUser(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        async beforeCellValChange2(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auwId = row.auwId
                    //console.log(jsonObj);
                    updateAjUserWord(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.wordData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.auId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            //console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.auId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.formDatas.checkStatus = 2;
            getAjUserListHeader(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.formDatas.checkStatus = 2;
            getAjUserListHeader(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            this.formDatas.checkStatus = 2;
            getAjUserListHeader(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
    padding: 0 !important;
    line-height: 1 !important;
}
</style>